/** Признак macOS: вне браузера, где определять не по чему, — ложь */
export const isMac = typeof window !== 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
